import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FilterType, IAdvancedFilter, IBasicFilter, IHierarchyFilter, IHierarchyFilterNode, IRelativeDateFilter, IRelativeDateTimeFilter, IRelativeTimeFilter, ISlicerFilter, ISlicerState, ITopNFilter } from 'powerbi-models';



@Injectable({ providedIn: 'root' })
export class PowerBiSlicerDescriptionService {


    constructor(
        private toasterService: ToastrService
    ){
        
    }
    
    describeFilters(slicerState: ISlicerState): {
              table: string;
              column: string;
              values: string;
            }[] 
    {
        if (!slicerState) return [];

        var targetDesriptions: {
              table: string;
              column: string;
              values: string;
            }[]  = [];

        const filters = slicerState.filters;
        const targets = slicerState.targets;
        
        if(targets && targets.length>0)
        {
            for(const target of targets) {
                
                const table_name = target.table;

                const genTarget = target as any;
                const column_name = genTarget.column??null;
                var parts = this.getFilterDescription(filters,table_name,column_name);
                targetDesriptions.push({
                            table: table_name??'?',
                            column: column_name??'?',
                            values: parts.join(' AND ')
                        });
            }
        }
        else{
            var parts = this.getFilterDescription(filters,null,null);
            targetDesriptions.push({
                    table: '{No Target}',
                    column: '{No Target}',
                    values: parts.join(' AND ')
                });
        }

        

      return targetDesriptions;
    }

    getFilterDescription(
        filters: any[],
        table_name: string|null,
        column_name: string|null
    ) : string[]
    {
    
      const parts: string[] = [];

      const matchingFilters = this.findFilterForTarget(filters, table_name,column_name);
      for (const filter of matchingFilters) {
          try {
              const schema = filter.$schema || '';
              let desc = '';
              switch (filter.filterType) {
                  case FilterType.Basic:
                      desc = this.describeBasicFilter(filter as IBasicFilter);
                      break;
                      
                case FilterType.Hierarchy:
                      desc = this.describeHirarchycFilter((filter as IHierarchyFilter).hierarchyData);
                      break;

                // --- ADVANCED FILTER ---
                case FilterType.Advanced:
                    desc = this.describeAdvancedFilter(filter as IAdvancedFilter);
                    break;

                // --- RELATIVE DATE FILTER ---
                case FilterType.RelativeDate:
                    desc = this.describeRelativeDateFilter(filter);
                    break;

                // --- TOP N FILTER ---
                case FilterType.TopN:
                    desc = this.describeTopNFilter((filter as any) as  ITopNFilter);
                    break;

                // --- INCLUDE / EXCLUDE (Visual filters) ---
                case FilterType.IncludeExclude:
                    desc = this.describeIncludeExcludeFilter(filter);
                    break;

                case FilterType.HierarchyIdentity:
                case FilterType.Identity:
                case FilterType.RelativeTime:
                case FilterType.Tuple:
                    
                    desc = `[Unmapped filter schema: ${schema}] ` + JSON.stringify(filter);
                    break;
                default:
                    desc = `[Unknown filter type: ${schema}] ` + JSON.stringify(filter);
              }

              parts.push(`${FilterType[filter.filterType]}: ${desc}`);
          } catch (err) {
              parts.push('Error parsing: ' + JSON.stringify(filter));
          }
      }

      if(matchingFilters.length==0){
        parts.push('Not Assigned: []');
      }
      return parts;
  }



  private describeBasicFilter( f: IBasicFilter): string {
      const op = f.operator || 'In';
      const vals = f.values || [];
      if (!vals.length) return `All`;
      if (vals.length === 1) return `${op} ${vals[0]}`;
      return `${op} (${vals.join(', ')})`;
  }
  
  private describeHirarchycFilter( hierarchyData: IHierarchyFilterNode[]): string {
    //return JSON.stringify(f.hierarchyData);
    if(!hierarchyData) return '';

    const mappedData = hierarchyData.map((h)=>{
        const op = h.operator??'?'
        const vals = h.keyValues;
        
        var desc='';
        if(vals){
            if (!vals.length) 
                desc = `All`;
            else if (vals.length === 1) desc = `${vals[0]}`;  
            else
                desc = `(${vals.join(', ')})`;
        }
        else{
            desc = `${h.value}`;  
        }

        if(h.children)
        {
            var cd = this.describeHirarchycFilter(h.children!);
            return `${op} ${desc} WITH (${cd})`;
        }
        return `${op} ${desc}`;
    })

    return mappedData.join(' ALSO ')
  }



  private describeAdvancedFilter( f: IAdvancedFilter): string {
    
      const cond1 = this.describeCondition(f.logicalOperator, f.conditions?.[0]);
      const cond2 = this.describeCondition(f.logicalOperator, f.conditions?.[1]);
      return [cond1, cond2].filter(Boolean).join(' ');
  }



  private describeCondition(logicalOp: string, c: any): string {
      if (!c) return '';
      const { operator, value } = c;
      const op = operator ? this.symbolForOperator(operator) : '';
      return `${logicalOp ? logicalOp + ' ' : ''}${op} ${value}`;
  }



  private symbolForOperator(op: string): string {
      const map: any = {
          LessThan: '<',
          LessThanOrEqual: '<=',
          GreaterThan: '>',
          GreaterThanOrEqual: '>=',
          Equal: '=',
          NotEqual: '≠',
          Contains: 'contains',
          DoesNotContain: 'not contains',
          StartsWith: 'starts with',
          Is: 'is',
          IsNot: 'is not'
      };
      return map[op] || op;
  }



  private describeRelativeDateFilter( f: any): string {
      const period = f.timeUnit || 'days';
      const range = f.relativePeriod || 0;
      const includeToday = f.includeToday ? 'including today' : 'excluding today';
      if (range === 0) return `Today`;
      if (range > 0) return `Next ${range} ${period} (${includeToday})`;
      return `Last ${Math.abs(range)} ${period} (${includeToday})`;
  }



  private describeTopNFilter(f: ITopNFilter): string {
      const n = f.itemCount || 10;
      const orderBy: any = f.orderBy;
      const measure = orderBy?.displayName || orderBy?.column || orderBy?.measure||'{Unkown}';
      return `${f.operator} ${n} by ${measure}`;
  }



  private describeIncludeExcludeFilter(f: any): string {
  const vals = f.values || [];
     const mode = f.isExclude ? 'excluding' : 'including';
      if (!vals.length) return `All`;
      return `${mode} (${vals.join(', ')})`;
  }

  
    findFilterForTarget(
        filters: ISlicerFilter[],
        table_name: string|null,
        column_name: string|null)
    :ISlicerFilter[]
    {
      if(!filters || filters.length==0) return [];
  
      var matches: ISlicerFilter[] = [];

      try{
        
        for(const f of filters)
        {
          if(Array.isArray(f.target)){
            const filterTargets = f.target as any[];
            
            for(const ft of filterTargets){
              if(this.isFilterMatching(ft, table_name, column_name)){
                matches.push(f)
              }
            }
          }
          else{
            if(this.isFilterMatching(f.target, table_name, column_name)){
                matches.push(f)
            }
          }
        }
      }
      catch(e){
        this.toasterService.error(JSON.stringify(filters));
      }

      return  matches;
    }

    isFilterMatching(
        ft:any,
        table_name: string|null,
        column_name: string|null
    ): boolean
    {
        if(table_name==null) return true;

        if(column_name!=null)
        return (ft.table== table_name) && (ft.column == column_name);
        
        return (ft.table== table_name);
    }
}
 